/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAlertSmallOff = createReactComponent("alert-small-off", "IconAlertSmallOff", [
  ["path", { d: "M12 16h.01", key: "svg-0" }],
  ["path", { d: "M12 7v1", key: "svg-1" }],
  ["path", { d: "M3 3l18 18", key: "svg-2" }]
]);

export { IconAlertSmallOff as default };
//# sourceMappingURL=IconAlertSmallOff.js.map
